import React from "react";
import { CanceledGroupMemberDetailsFragment } from "generated/graphql";
import { useI18n } from "@wojo/localization";
import { Card, Text } from "@wojo/ui";
import { useId } from "react";
import { CanceledTravelersTable } from "./CanceledTravelersTable";
import { MarkdownForNextLinks } from "components/markdown-for-next-links";

export type CanceledTravelersProps = {
    canceledTrips: CanceledGroupMemberDetailsFragment[];
};

export const CanceledTravelers: React.FC<CanceledTravelersProps> = ({
    canceledTrips,
}) => {
    const headingId = useId();
    const i18n = useI18n("account").account.myGroupMembers.canceledTravelers;
    const canceledGroupMembers = canceledTrips;

    if (!canceledGroupMembers.length) {
        return null;
    }

    return (
        <section
            aria-labelledby={headingId}
            style={{
                paddingTop: "var(--g-spacing-lg)",
                marginBottom: "var(--g-spacing-xl)",
            }}
        >
            <Text.Heading
                id={headingId}
                order="3"
                tag="h2"
                style={{ paddingBottom: "var(--g-spacing-sm)" }}
            >
                {i18n.heading.l()}
            </Text.Heading>
            <MarkdownForNextLinks
                style={{
                    paddingBottom: "var(--g-spacing-lg)",
                }}
                markdown={i18n.description.l()}
            />
            <Card>
                <CanceledTravelersTable
                    canceledTravelers={canceledGroupMembers}
                />
            </Card>
        </section>
    );
};
